// extracted by mini-css-extract-plugin
export default {"simpleButton":"globals_simpleButton__n9hX9"};